export default "__VITE_ASSET__CZeN0_Ju__"